import { render, staticRenderFns } from "./MatchPairSlideOptions.vue?vue&type=template&id=4d68c6f6&"
import script from "./MatchPairSlideOptions.vue?vue&type=script&lang=js&"
export * from "./MatchPairSlideOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports